module.exports = __webpack_public_path__ + "static/directrice-1e8e58a75eae7091228d70646e42fa0d.jpg";